import { selector } from 'recoil';

import { Store } from '~/types';
import { storeLocaleSelector } from './storeLocale';

type PickOperatingTime = Pick<Store, 'operatingTime'>;

export type OperatingTime = PickOperatingTime[keyof PickOperatingTime];

const operatingTimeSelector = selector<OperatingTime | null>({
  key: 'operatingTimeSelector',
  get: ({ get }) => {
    const store: Store | null = get(storeLocaleSelector);
    return store?.operatingTime || null;
  },
});

export default operatingTimeSelector;
